const NotificationIcon = ({ avatarSrc, subIcon }) => {
  return (
    <div className="relative min-w-8 min-h-8 max-w-8 max-h-8">
      {typeof avatarSrc === 'string' ? (
        <img className="w-8 h-8 rounded-full object-cover" src={avatarSrc} alt="" />
      ) : (
        <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center">
          <img src={avatarSrc} alt="" className="w-6 h-6" />
        </div>
      )}
      {subIcon && (
        <div className="absolute -bottom-2 -right-2 w-5 h-5 rounded-full bg-white flex items-center justify-center">
          {typeof subIcon === 'string' ? <img src={subIcon} alt="" className="w-5 h-5" /> : subIcon}
        </div>
      )}
    </div>
  );
};

export default NotificationIcon;
